import s from './SvgLoader.scss';

const SvgLoader = ({ color = '#5A6BD8', bg = '#ECEEFF', size = '2.5rem' }) => {
  return (
    <svg className={s.Spinner} viewBox='0 0 50 50' width={size} height={size}>
      <circle className={s.Inner} cx='25' cy='25' r='20' fill='none' stroke={bg} strokeWidth='6'></circle>
      <circle className={s.Path} cx='25' cy='25' r='20' fill='none' stroke={color} strokeWidth='6'></circle>
    </svg>
  );
};

export default SvgLoader;
